import { PropTypes } from 'prop-types';
import React from 'react';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';

const CardTextBasedXSmall = ({
  className = 'flex flex-col pt-6 pb-8 border-t border-b sm:pt-8 border-smoke text-hover',
  date: _date,
  slug,
  title,
}) => {
  const date = getFormattedDate(_date);

  return (
    <Link className={className} to={`/article/${slug}/`}>
      <h5 className="stink-h5 ">{title}</h5>
      {date && <p className="mt-2 stink-footnote text-slate">{date}</p>}
    </Link>
  );
};

CardTextBasedXSmall.propTypes = {
  className: PropTypes.string,
  date: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
};

export default CardTextBasedXSmall;
